import { Form7, Request } from "../../../../../models/Request";

export const createEarlyEnrollmentApprovedPayload = (
  form7: Form7,
  item: Request,
  value: boolean
): Form7 => ({
  ...form7,
  isEarlyEnrollmentApproved: value,
  isEarlyEnrollmentRejected: !value,
  isEnrollmentPostponement: false,
  isTemporaryExemptionApproved: false,
  isTemporaryExemptionRejected: false,
  isAppropriateProgram: false,
  isPreparatoryCourse: false,
  institutionId: value ? item.institutionId : undefined,
});

export const createEarlyEnrollmentRejectedPayload = (
  form7: Form7,
  item: Request,
  value: boolean
): Form7 => ({
  ...form7,
  isEarlyEnrollmentApproved: !value,
  isEarlyEnrollmentRejected: value,
  isEnrollmentPostponement: false,
  isTemporaryExemptionApproved: false,
  isTemporaryExemptionRejected: false,
  isAppropriateProgram: false,
  isPreparatoryCourse: false,
  institutionId: value ? undefined : item.institutionId,
});

export const createEnrollmentPostponementPayload = (
  form7: Form7,
  item: Request,
  value: boolean
): Form7 => ({
  ...form7,
  isEarlyEnrollmentApproved: false,
  isEarlyEnrollmentRejected: false,
  isEnrollmentPostponement: value,
  isTemporaryExemptionApproved: false,
  isTemporaryExemptionRejected: false,
  isAppropriateProgram: false,
  isPreparatoryCourse: false,
  institutionId: value ? undefined : item.institutionId,
});

export const createTemporaryExemptionApprovedPayload = (
  form7: Form7,
  item: Request,
  value: boolean
): Form7 => ({
  ...form7,
  isEarlyEnrollmentApproved: false,
  isEarlyEnrollmentRejected: false,
  isEnrollmentPostponement: false,
  isTemporaryExemptionApproved: value,
  isTemporaryExemptionRejected: !value,
  isAppropriateProgram: false,
  isPreparatoryCourse: false,
  institutionId: undefined,
});

export const createTemporaryExemptionRejectedPayload = (
  form7: Form7,
  item: Request,
  value: boolean
): Form7 => ({
  ...form7,
  isEarlyEnrollmentApproved: false,
  isEarlyEnrollmentRejected: false,
  isEnrollmentPostponement: false,
  isTemporaryExemptionApproved: !value,
  isTemporaryExemptionRejected: value,
  isAppropriateProgram: false,
  institutionId: undefined,
});

export const createAppropriateProgramPayload = (
  form7: Form7,
  item: Request,
  value: boolean
): Form7 => ({
  ...form7,
  isEarlyEnrollmentApproved: false,
  isEarlyEnrollmentRejected: false,
  isEnrollmentPostponement: false,
  isTemporaryExemptionApproved: false,
  isTemporaryExemptionRejected: false,
  isAppropriateProgram: value,
  institutionId: item.institutionId,
});

export const createPreparatoryCoursePayload = (
  form7: Form7,
  item: Request,
  value: boolean
): Form7 => ({
  ...form7,
  isPreparatoryCourse: value,
  institutionId: value ? item.institutionId : form7.institutionId,
});
